import {combineReducers} from 'redux';
import reducer from './reducer';

const rootReducers = combineReducers({
    reducer,
})

export default rootReducers;